export const tag = {
  search: {
    placeholder: { en: 'search by tag', ko: '태그를 입력하세요.', fr: '' },
  },
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    tag: { en: 'Tag', ko: '태그', fr: '' },
    lastUpdateTimestamp: { en: 'Update date', ko: '수정날짜', fr: '' },
  },
  info: {
    tag: { en: 'Tag', ko: '태그', fr: '' },
    lastUpdateTimestamp: { en: 'Update date', ko: '수정날짜', fr: '' },
  },
};
